export const GET_BRANCHES = 'GET_BRANCHES';
